import { render } from "./v-calendar.vue?vue&type=template&id=67acccb7&scoped=true"
import script from "./v-calendar.vue?vue&type=script&lang=js"
export * from "./v-calendar.vue?vue&type=script&lang=js"

import "./v-calendar.vue?vue&type=style&index=0&id=67acccb7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67acccb7"]])

export default __exports__